import request from '../utils/request';

// 获取房源列表
export const getApartmentList = (data) => {
  return request({
    url: '/api/manage/getHouseList',
    method: 'post',
    data
  });
};

// 获取房源详情
export const getApartmentDetail = (id) => {
  return request({
    url: `/api/manage/getHouseDetail/${id}`,
    method: 'get'
  });
};

// 创建房源
export const createApartment = (data) => {
  return request({
    url: '/api/manage/addHouse',
    method: 'post',
    data
  });
};

// 更新房源
export const updateApartment = (data) => {
  return request({
    url: '/api/manage/updateHouse',
    method: 'post',
    data
  });
};

// 删除房源
export const deleteApartment = (id) => {
  return request({
    url: `/api/manage/deleteHouse/${id}`,
    method: 'get'
  });
};

// 上传文件
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: '/api/manage/uploadFile',
    method: 'post',
    data: formData
  });
};

